import React from 'react';
import styles from './TutorialModal.module.css';

const TutorialModal = ({ onClose }) => {
    return (
        <div className={styles.tutorialModal}>
            <div className={styles.content}>
                <h2>How to use the Swiss Virtual Clinic</h2>
                <div className={styles.tutorialSection}>
                    <h3>Navigation</h3>
                    <p>Visit the different sections of our Swiss Virtual Clinic using the navigation tabs at the bottom left of the screen</p>
                </div>
                <div className={styles.tutorialSection}>
                    <h3>Interaction Points</h3>
                    <p>Click on the highlighted white interaction points to discover details content and information for each section</p>
                </div>
                <div className={styles.tutorialSection}>
                    <h3>Contact Us</h3>
                    <p>Reach us at <a href="mailto:info@sav-iol.com">info@sav-iol.com</a> for any questions, comments or suggestions.</p>
                </div>
                <button className={styles.closeButton} onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

export default TutorialModal; 